<!-- prettier-ignore -->   

<button 
  hammerLongPress
  type="button" 
  class="chat__button"
  [class.isstop]="!showRecordIcon() && isRecording()"
  [class.isrecording]="showRecordIcon() && isRecording()" 
  (shortTap)="onShortTap()"
  (longPressStart)="onLongPressStart()"
  (longPressEnd)="onLongPressEnd()"
>
  
  @if(showRecordIcon() && isRecording()){
    <icon-pulse />
  } @else if(isRecording() && !isPlayingWelcome()){
    <cancel-button />
  } @else if (isPlayingWelcome()) {
    <loader-button />
  } @else{
    <icon-voice />
  }
</button>
